import { lazy } from 'react';

import { SURVEY_ANALYTICS_MODAL } from 'modules/SurveyAnalytics/constants';

const StudentListDrawer = lazy(() =>
  import('modules/SurveyAnalytics/modals/StudentListDrawer'),
);
const TextQuestionDetailModal = lazy(() =>
  import('modules/SurveyAnalytics/modals/TextQuestionDetailModal'),
);
const OtherAnswerListModal = lazy(() =>
  import('modules/SurveyAnalytics/modals/OtherAnswerListModal'),
);
const VideoResponseQuestionModal = lazy(() =>
  import('modules/SurveyAnalytics/modals/VideoResponseModal'),
);

export default {
  [SURVEY_ANALYTICS_MODAL.STUDENT_LIST_DRAWER]: StudentListDrawer,
  [SURVEY_ANALYTICS_MODAL.TEXT_QUESTION_DETAIL_MODAL]: TextQuestionDetailModal,
  [SURVEY_ANALYTICS_MODAL.OTHER_ANSWER_LIST_MODAL]: OtherAnswerListModal,
  [SURVEY_ANALYTICS_MODAL.VIDEO_RESPONSE_MODAL]: VideoResponseQuestionModal,
};
